import { branch, compose, renderNothing } from 'recompose';
import { canUserViewWaitingList } from '../../../../../common/helpers/users';
import WalkInListButton from '../components/WalkInListButton';
import withPermissions from '../../../../../auth/utils/withPermissions';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../../../../modules/infra/feature-flags';
import { getActiveShop, isBarberUser } from '../../../../../auth/selectors';
import { connect } from 'react-redux';

const WalkInListButtonContainer = compose(
  withInjectFeatureFlagsToProps([flagNames.WALK_IN_LIST]),
  withPermissions,
  connect((state) => ({
    shop: getActiveShop(state),
    isBarberUser: isBarberUser(state),
  })),
  branch((props) => {
    // Only show if walk-in list feature flag is enabled
    if (!props[flagNames.WALK_IN_LIST]) return false;

    // Only show for shop users (not barbers)
    if (props.isBarberUser) return false;

    // Only show if shop has walk-in list enabled
    if (!props.shop?.settings?.walkInListEnabled) return false;

    return true;
  }, renderNothing)
)(WalkInListButton);

export default WalkInListButtonContainer;
